export function displayItemName(item?: any): string {
  return item?.name || '';
}
